/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';

import _ from 'lodash';

import useResponsive from '../../../utils/responsive';

import { FadeInAnimation, Shapes } from '../shared';

import Image from '../shared/image.component';

const AboutCitySection = (props) => {

    const { data, cityName, buildings } = props;

    const { isMobile } = useResponsive();    

    const city = _.find(data, (detail) => _.trim(detail.city_name.replace(/_/g, '')) === cityName);

    const renderRandomBuildingImage = () => {
        const keys = Object.keys(buildings);
        const randomBuilding = buildings[keys[Math.floor(Math.random() * _.size(keys))]];
        return _.get(randomBuilding, 'images[0]');
    };

    const renderImageSection = () => {
        if (isMobile) {
            return (
                <>
                    <Shapes
                        isCircle
                        isPair
                        isSmallDark
                        isOpposite
                        speed={0.07}
                        containerMargins={{ left: '91%', top: '10%' }}
                        smallRadius={11.82}
                        largeRadius={28.15}
                        distanceBetween={{ width: '40%', height: '5%' }}
                        zIndex={2}
                    />
                    <Shapes
                        isDots
                        speed={-0.07}
                        containerMargins={{ top: '15%', left: '-6%' }}
                        smallMargins={{ width: '50%', height: '80%' }}
                    />
                    <Image
                        className="play-page-about-city-section-image card-image"
                        src={renderRandomBuildingImage()}
                        alt="featured-building"
                        isOldImage
                    />
                </>
            );
        }
        return (
            <>
                <Shapes
                    isCircle
                    isPair
                    isSmallDark
                    isOpposite
                    speed={0.07}
                    containerMargins={{ left: '91%', top: '-10%' }}
                    smallRadius={21}
                    largeRadius={50}
                    distanceBetween={{ width: '40%', height: '5%' }}
                    zIndex={2}
                />
                <Shapes
                    isDots
                    speed={-0.07}
                    containerMargins={{ top: '-5%', left: '-14%' }}
                    smallMargins={{ width: '45%', height: '90%' }}
                />
                <Image
                    className="play-page-about-city-section-image card-image"
                    src={renderRandomBuildingImage()}
                    alt="featured-building"
                    isOldImage
                />
            </>
        );
    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='main-grid-container play-page-about-city-section-grid-container'>

                <div className='main-grid-item main-grid-md-6'>

                    <div className='play-page-about-city-section-left-container'>

                        <FadeInAnimation>

                            <h2>About {cityName}</h2>

                        </FadeInAnimation>

                        <FadeInAnimation>

                            <p className='play-page-about-city-section-paragraph'>{_.get(city, 'paragraph_one')}</p>

                        </FadeInAnimation>

                        <FadeInAnimation>

                            <p className='play-page-about-city-section-paragraph'>{_.get(city, 'paragraph_two')}</p>

                        </FadeInAnimation>

                    </div>

                </div>

                <div className='main-grid-item main-grid-md-6'>

                    <div className='hero-section-image-container'>{renderImageSection()}</div>

                </div>

            </div>

        </div>

    );
};

export default AboutCitySection;

AboutCitySection.propTypes = {
    cityName: PropTypes.string,
    data: PropTypes.array,
    buildings: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

